import type { TranslateLoader } from '@ngx-translate/core';
import type { Observable } from 'rxjs';
import type { HttpClient } from '@angular/common/http';
import type { CookieService } from 'ngx-cookie-service';

import { ELanguages } from '@common/enums';

export class TranslationLoaderService implements TranslateLoader {
    constructor(
        private readonly http: HttpClient,
        private readonly cookieService: CookieService
    ) {}

    public static getCurrentLocale(cookieService: CookieService): ELanguages {
        const langCookie: string = cookieService.get('lang');
        return (langCookie ? langCookie.split(':')[0] : ELanguages.EN) as ELanguages;
    }

    public getTranslation(): Observable<any> {
        return this.http.get(
            `./assets/translations/${TranslationLoaderService.getCurrentLocale(this.cookieService)}.json`
        );
    }
}
